import React, { useState, useEffect } from "react";
import ReceivablesTable from "../accounts_receivable/ReceivablesTable";
import TitledSection from "../../../../components/generic/titledSection";
import { MercoaSession } from "@mercoa/react";
import PayablesTable from "../accounts_payable/PayablesTable";
import "@mercoa/react/dist/style.css";
import StyledAlert from "../../../../components/generic/StyledAlert";
import AparEntitySelector from "./AparEntitySelector";
import { backendGetRequest } from "../../../../helpers/callBackend";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import theme from "../../../../helpers/theme";
import { Button } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import HeaderBox from "../../../../components/generic/arpariBoxes/headerBox";
import OuterBox from "../../../../components/generic/arpariBoxes/OuterBox";
import { useUcs } from "../../../../helpers/contexts/UserCompanySettingsContext";

/**
 *
 * @param {string} title determines weather to present AR/AP
 * @returns
 */
const AparDash = ({ title }) => {
  const [entityId, setEntityId] = useState(
    localStorage.getItem("mercoa_entity_id")
  );
  const [mercoaToken, setMercoaToken] = useState("");
  const [entitiesLoaded, setEntitiesLoaded] = useState(false);
  const [userHasRestrictedAccess, setUserHasRestrictedAcces] = useState(true)

  const ucsContext = useUcs();

  useEffect(() => {
    if (ucsContext.loaded) {
      setUserHasRestrictedAcces(ucsContext.hasLimitedAccountAccess())
      if (!ucsContext.hasLimitedAccountAccess()) {
        let token = getToken();
        setMercoaToken(token);
      }
    }
  }, [ucsContext])

  const getToken = async () => {
    const tokenResponse = await backendGetRequest("/api/arpari-mercoa/token/");
    if (tokenResponse?.status !== 200) {
      console.error("Error fetching token:", tokenResponse?.error);
    } else {
      setMercoaToken(tokenResponse.data.description);
    }
  };

  const refreshMercoa = async () => {
    const refreshUrl = "api/arpari-mercoa/refresh/";
    const paginationInfo = await backendGetRequest(refreshUrl, {
      params: { page_index: 0 },
    });
    if (paginationInfo?.status !== 200) {
      console.error("Error refreshing page information", paginationInfo?.error);
      return;
    }

    let pageResponse = null;
    for (
      let pageNum = 1;
      pageNum <= paginationInfo.data.total_pages;
      pageNum++
    ) {
      pageResponse = await backendGetRequest(refreshUrl, {
        params: { page_index: pageNum },
      });
      if (pageResponse?.status !== 200) {
        console.error(`Error refreshing page #${pageNum}`, pageResponse?.error);
      }
    }
  };

  useEffect(() => {
    if (mercoaToken) {
      refreshMercoa();
      localStorage.setItem("mercoa_token", mercoaToken);
    }
  }, [mercoaToken]);

  return (
    <OuterBox>
      <Box sx={{ margin: theme.dashboard.margins }}>
        <HeaderBox
          title={`Accounts ${title}`}
          actions={
            <Button
              disableElevation
              fullWidth
              size="small"
              type="submit"
              variant="contained"
              color="primary"
              disabled={entityId ? false : true}
              htmlType="submit"
              sx={{
                fontSize: 14,
                width: "100%",
                textTransform: "none",
              }}
            >
              <Link
                to={`${title.toLowerCase()}invoice/${entityId}/new`}
                style={{ color: "white" }}
              >
                + Add New {title}
              </Link>
            </Button>
          }
        />
        {!userHasRestrictedAccess && (
          <AparEntitySelector
            setEntityId={setEntityId}
            entityId={entityId}
            setEntitiesLoaded={setEntitiesLoaded}
          />
        )}
        {entitiesLoaded && !entityId && !userHasRestrictedAccess && (
          <StyledAlert
            message={`Please select an entity to view ${title.toLowerCase()}s`}
            severity="warning"
            marginTop="15px"
          />
        )}
        {userHasRestrictedAccess && (
          <StyledAlert
            message={`Users with limited account access do not have access to accounts ${title.toLowerCase()}.`}
            severity="warning"
            marginTop="15px"
          />
        )}
        {entitiesLoaded && typeof mercoaToken === "string" && mercoaToken && (
          <MercoaSession token={mercoaToken} entityId={entityId}>
            {title.toLowerCase() === "receivable" && <ReceivablesTable />}
            {title.toLowerCase() === "payable" && <PayablesTable />}
          </MercoaSession>
        )}
        {!entitiesLoaded && (
          <Box container sx={{ marginTop: "5%" }}>
            <Box
              direction="row"
              display="flex"
              gap="1%"
              sx={{ marginBottom: "5px" }}
            >
              <Skeleton
                variant="rounded"
                sx={{ width: "33%", height: "80px" }}
              />
              <Skeleton
                variant="rounded"
                sx={{ width: "33%", height: "80px" }}
              />
              <Skeleton
                variant="rounded"
                sx={{ width: "33%", height: "80px" }}
              />
            </Box>
            <Skeleton variant="text" sx={{ width: "100%" }} />
            <Skeleton variant="text" sx={{ width: "100%" }} />
            <Skeleton variant="text" sx={{ width: "100%" }} />
            <Skeleton variant="text" sx={{ width: "100%" }} />
            <Skeleton variant="text" sx={{ width: "100%" }} />
            <Skeleton variant="text" sx={{ width: "100%" }} />
          </Box>
        )}
      </Box>
    </OuterBox>
  );
};
export default AparDash;
